import React, { Component } from 'react';
import ModalConnection from './ModalConnectionSubscribe';
import {doSignOut} from '../authDB';


class App extends Component {
    show_connection(){
        this.refs.ModalConnection.handleShow();
    console.log(this.refs)
    }
    Deconx(){
      localStorage.removeItem('user')
      doSignOut().then(()=>{
        window.parent.location = window.parent.location.href;
    
      })
    }
  render() {
      
    return (
   <div>
       
       <header className="header">
            <div className="container">
                <div className="menubar">
                    <div className="row">
                        <div className="col-md-12">
                            <nav className="navbar navbar-static-top">
                             <div className="navbar-header">
                                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" aria-expanded="false">
                                        <span className="sr-only">Toggle navigation</span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                    </button>
                                    <a className="navbar-brand" href="/">
                                        <img src="/images/logo.png" className="img-responsive" alt="logo"/>
                                    </a>
                                </div>                      
     <div className="collapse navbar-collapse ">
                                    <ul className="nav navbar-nav navbar-right">
                                    
                                    <li className="res-btn">
                                          {(JSON.parse(localStorage.getItem('user')))?  <button onClick={()=>this.Deconx()} className="book-btn">Déconnection</button>:<button onClick={()=>this.show_connection()} className="book-btn">Connexion</button>}
                                    </li>
                                    </ul>
                                    <ul className="nav navbar-nav navbar-right" id="main-menu">

                                    <li className="">

                                         <a  href="/">
                                                Accueil
                                         </a>
                                    </li>
                                        {/*    <li className="">
                                            <a  href="/about">À propos</a>
    </li>*/}
                                        <li className="">
                                            <a  href="/order">Menu</a>                                          
                                        </li>
                                        {(JSON.parse(localStorage.getItem('user')))?  <li className="">
                                            <a  href="/historique">Historique</a>
                                        </li>:null       }     
                                        {(JSON.parse(localStorage.getItem('user')))?   <li className="">
                                            <a href="/loyalty">
                                            Fidélité
                                            </a>
                                        </li>  :null       } 
                                        <li className="">
                                            <a   href="/Blog">
                                                Blog
                                            </a>
                                        </li>     
                                                          
                                        <li className="">
                                            <a   href="/contact">
                                                Contact
                                            </a>
                                        </li>  
                                                                           
                                    </ul>
                                </div>  
                            </nav>
                        </div>
                    </div>
                </div>

            </div>
            <div className="mobile-menu" data-logo="/images/logo.png">


            </div>



        </header>
        <section className="page-title">
            <div className="container">
                <h2 className="title">
                    404 Erreur
                </h2>
                <ul className="brdcrumb clearfix">
                    <li>
                        <a href="index.html">Accueil</a>
                    </li>
                   
                    <li className="current">
                        404
                    </li>
                </ul>
            </div>
        </section>
         <section className="not-found text-center section-padding">
            <h2 className="big-title">Ooopps:(</h2>
            <p className="not-found-text">
                404
            </p>
            <p className="text-uppercase text-black">La page que vous cherchiez n'a pas pu être trouvée</p>
            <a href="/" className="btn-custom">Aller à Accueil</a>
        </section>

        <section className="call-out-section section-padding">
    <div className="container">
        <div className="row">
            <div className="col-md-10">
                <h2>Découvrez le vrai goût de nos Plats.</h2>
            </div>
            <div className="col-md-2">
                <div className="call-out-btn">
                    <a href="/contact" className="btn-custom">Contactez nous</a>
                </div>
            </div>
        </div>
    </div>
</section>
<ModalConnection ref="ModalConnection"/>

    </div>


      

   
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/container/404.js